<template>
  <div>

    <v-layout column wrap>
      <v-card>
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">LIST OF FLOATING MEMBERS</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-data-table
          :height="height"
          :headers="headers"
          :items="list_of_new_member"
          :search="search"
          :loading="data_table_loading"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <span class="headline">TOTAL: {{ list_of_new_member.length }}</span>
              <v-divider
                class="mx-4"
                inset
                vertical
              ></v-divider>
              <span class="headline" v-if="can_print">
                                                Print
                                                <v-icon
                                                  class="mr-2"
                                                  color="warning"
                                                  @click="print_data()"
                                                >
                                                {{ icons.mdiPrinter }}
                                                </v-icon>
                                            </span>
              <v-spacer></v-spacer>

              <v-text-field
                class="mx-2"
                :append-icon="icons.mdiAccountSearchOutline"
                label="Search"
                single-line
                hide-details
                v-model="search"
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:item.status="{ item }">
            <div v-if="position==='ADMIN'">
              <v-icon
                class="mr-2"
                color="error"
                @click="change_district(item)"
              >
                {{ icons.mdiLeadPencil }}
              </v-icon>
            </div>
          </template>
          <template v-slot:item.no="{ item }">
            {{
              list_of_new_member.map(function (x) {
                return x.id;
              }).indexOf(item.id) + 1
            }}
          </template>
        </v-data-table>
      </v-card>
    </v-layout>

    <v-dialog v-model="is_change_district" persistent max-width="80%">
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">CHANGE DISTRICT/CLUB AND POSITION</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-card>
        <v-row>
          <v-col
            md="9"
            cols="12"
          >
            <v-select
              class="mx-2"
              v-model="district"
              dense
              outlined
              label="District/Club"
              :items="district_items"
              item-value="id"
              item-text="district_name"
              :rules="rules.combobox_rule"
              @change="new_position='MEMBER'"
            ></v-select>
          </v-col>
          <v-col
            md="3"
            cols="12"
          >
            <v-select
              class="mx-2"
              v-model="new_position"
              dense
              outlined
              label="Position"
              :items="['DISTRICT PRESIDENT', 'VICE PRESIDENT', 'SECRETARY', 'TREASURER', 'AUDITOR', 'GCCFI STAFF', 'DISTRICT AFFAIR OFFICER', 'MEMBER']"
              :rules="rules.combobox_rule"
            ></v-select>
          </v-col>
          <v-col
            md="3"
            cols="12"
            class="mx-2"
          >
            <v-text-field
              v-model="effective"
              label="Effective Date"
              dense
              outlined
              :rules="rules.default_max_45_character_and_no_empty_rule"
              type="date"
              @change="date_actions"
            ></v-text-field>
          </v-col>
          <v-col
            md="3"
            cols="12"
          >
            <v-text-field
              v-model="expiration"
              label="Expiration Date"
              dense
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn color="primary" @click="save_change_districy"> Save Changes</v-btn>
          <v-btn color="error" @click="is_change_district = false"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import moment from "moment";
import {mdiAccountSearchOutline, mdiPrinter, mdiLeadPencil} from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiAccountSearchOutline,
        mdiPrinter,
        mdiLeadPencil,
      },
    }
  },
  data() {
    return {
      can_print: false,
      list_of_new_member: [],
      selected_member: {},

      is_change_district: false,
      district: '',
      new_position: '',
      effective: '',
      expiration: '',
      district_name: '',
      district_position: '',
      district_items: [],

      type_of_member: 'All',
      //table props
      search: '',
      data_table_loading: false,
      headers: [
        {text: 'No', value: 'no'},
        {text: 'CMF #', value: 'cmf_no'},
        {text: 'Last Name', value: 'last_name'},
        {text: 'First Name', value: 'first_name'},
        {text: 'From', value: 'latest_district_history.district.district_name'},
        {text: 'Status', value: 'status', sortable: false},
      ],
      height: 430
    }
  },
  mounted() {
    this.load_data()
    this.list_of_district()
      .then(response => {
        this.district_items = response.data
      })
  },
  computed: {
    ...mapGetters('form_rules', ['rules']),
    ...mapGetters('system_data', ['company_logo']),
    ...mapGetters('authentication', ['branch_id', 'branch', 'branch_address', 'branch_contact_no', 'position']),
  },
  watch: {
    branch_id: function () {
      this.can_print = false
      this.list_of_new_member = []
    }
  },
  methods: {
    ...mapActions('transaction_months', ['retrieve_transaction_month']),
    ...mapActions('members_information', ['list_of_floating_members']),
    ...mapActions('district_officers_history', ['save_new_officers_district']),
    ...mapActions('district', ['list_of_district']),
    load_data() {
      this.is_change_district = false
      this.data_table_loading = true
      this.list_of_floating_members()
        .then((response) => {
          this.can_print = true
          this.list_of_new_member = response.data
          this.data_table_loading = false
        })
        .catch(error => {
          console.log(error)
        })
    },
    date_actions() {
      this.expiration = moment(this.effective, 'YYYY-MM-DD').add(1, 'year').format('MM/DD/YYYY')
    },
    change_district(item) {
      this.is_change_district = true
      this.selected_member = item
    },
    save_change_districy() {
      this.save_new_officers_district({
        member_id: this.selected_member.id,
        position: this.new_position,
        date_started: this.effective,
        expiration_date: this.expiration,
        district_id: this.district,
      }).then(response => {
        var color = 'success'
        if (response.status === 201) {
          color = 'error'
        }
        this.change_snackbar({
          show: true,
          color: color,
          text: response.data,
        })
        this.load_data()
      })
        .catch(error => {
          this.alert = true
          this.alert_message = error
          this.saving = false
        })
    },
    print_data() {
      var imgData = this.company_logo
      var array = []
      array.push(
        [
          {text: 'No', alignment: 'center', style: 'label'},
          {text: 'Control No', alignment: 'center', style: 'label'},
          {text: 'Effective Date', alignment: 'center', style: 'label'},
          {text: 'Name', alignment: 'center', style: 'label'},
          {text: 'Status', alignment: 'center', style: 'label'},
        ]
      )

      if (this.list_of_new_member.length > 0) {
        this.list_of_new_member.forEach(function (item, index) {
          var status = 'PAID'
          if (item.type_of_member === 'Volunteer') {
            status = ''
          } else if (item.paid === 0) {
            status = 'UNPAID'
          }
          array.push(
            [
              {text: index + 1, alignment: 'center'},
              {text: item.cmf_no, alignment: 'left'},
              {text: item.date_accomplished, alignment: 'left'},
              {
                text: item.last_name + ', ' + item.first_name + ' ' + item.middle_name,
                alignment: 'left'
              },
              {text: status, alignment: 'center'},
            ]
          )
        })
      } else {
        array.push(
          [
            '----',
            '----',
            '----',
            '----',
            '----',
          ]
        )
      }
      //call pdfmake
      var pdfMake = require('pdfmake/build/pdfmake.js')
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require('pdfmake/build/vfs_fonts.js')
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      var docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: [
          {
            columns: [
              {image: imgData, width: 54, height: 54, style: 'logo'},
              {
                stack: [
                  'GOODLIFE COMMUNITY CARE FOUNDATION',
                  {text: this.branch_address, style: 'subheader'},
                  {
                    text: 'S.E.C REG. No. NA CONTACT NO.: ' + this.branch_contact_no,
                    style: 'subheader'
                  },
                ],
                style: 'header'
              },
            ]
          },
          {text: 'LIST OF FLOATING MEMBERS', style: 'title'},
          '================================================================================',
          {text: 'Printed as of: ' + moment().format('MMMM D, YYYY'), style: 'printed_label'},
          ' ',
          {
            style: 'tableExample',
            color: '#444',
            table: {
              widths: [30, 50, 70, 230, 50],
              body: array,
            },
            layout: {
              fillColor: function (rowIndex) {
                return (rowIndex === 0) ? '#CCCCCC' : null;
              },
            },
          },
          {
            stack: [
              {
                columns: [
                  {text: 'Prepared By: ', style: 'aa_top_margin'},
                  {text: 'Received By:', style: 'cashier_top_margin'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '', style: 'aa_for'},
                  {text: '', style: 'cashier_for'},
                  {text: ''},
                ]
              },
              {
                columns: [
                  {text: '_________________________________', style: 'aa_line'},
                  {text: '_________________________________', style: 'cashier_line'},
                  {text: ''},
                ]
              },
            ]
          },
          {
            stack: [
              {
                columns: [
                  {text: 'Verified By: ', style: 'bm_top_margin'},
                  {text: 'Audited By: ', style: 'au_top_margin'},
                ]
              },
              {
                columns: [
                  {text: '', style: 'bm_for'},
                  {text: '', style: 'au_for'},
                ]
              },
              {
                columns: [
                  {text: '_________________________________', style: 'bm_line'},
                  {text: '_________________________________', style: 'au_line'},
                ]
              },
              {
                columns: [
                  {text: 'Branch Manager', style: 'bm_placeholder'},
                  {text: 'Asst. Auditor', style: 'au_placeholder'},
                ]
              },
            ]
          },
        ],
        footer: {
          columns: [
            {
              text: 'Generated with Goodlife Savings & Credit Cooperative System',
              alignment: 'center',
              style: 'tableExample'
            }
          ]
        },
        styles: {
          header: {
            fontSize: 21,
            bold: true,
            alignment: 'left',
            margin: [6, 6, 0, 20]//[left, top, right, bottom]
          },
          subheader: {
            fontSize: 12
          },
          title: {
            fontSize: 15,
            alignment: 'center',
          },
          logo: {
            alignment: 'center',
            margin: [0, 0, 0, 0]//[left, top, right, bottom]
          },
          printed_label: {
            alignment: 'right',
            fontSize: 9,
            margin: [0, 4, 0, 0]//[left, top, right, bottom]
          },
          main_info: {
            margin: [0, 2, 0, 2],
            fontSize: 10,
          },
          sub_info: {
            margin: [0, 2, 0, 2],
            fontSize: 8,
          },
          tableExample: {
            fontSize: 7,
          },

          aa_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          bm_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          cs_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          aa_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_placeholder: {
            margin: [15, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          aa_for: {
            margin: [0, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_for: {
            margin: [3, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cashier_placeholder: {
            margin: [26, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          cs_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          bm_placeholder: {
            margin: [5, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_top_margin: {
            margin: [0, 10, 0, 0],
            alignment: 'left',
            fontSize: 7,
          },
          au_placeholder: {
            margin: [2, 2, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_for: {
            margin: [2, 15, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
          au_line: {
            margin: [0, 0, 0, 2],
            alignment: 'left',
            fontSize: 7,
          },
        },
      }
      pdfMake.createPdf(docDefinition).open();
    },
  }
}
</script>
